import styled from 'styled-components';

export const SearchWrapper = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px;
`;

export const AssigneeWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 16px;
`
export const CheckboxGroup = styled.div`
  width: 100%;
  margin-top: 16px;
`